/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { RechteIdMeta } from './rechteIdMeta';
import { RechtVersionListEntryMeta } from './rechtVersionListEntryMeta';
import { RechtMasterIdMeta } from './rechtMasterIdMeta';


export interface RechtMasterListEntryMeta { 
    rechteId?: RechteIdMeta;
    mRechteId?: FieldMetaData;
    id?: RechtMasterIdMeta;
    mId?: FieldMetaData;
    version?: RechtVersionListEntryMeta;
    mVersion?: FieldMetaData;
    art?: RechtMasterListEntryMeta.ArtEnum;
    mArt?: FieldMetaData;
    isNavigierbar?: boolean;
    mIsNavigierbar?: FieldMetaData;
}
export namespace RechtMasterListEntryMeta {
    export type ArtEnum = 'DIENSTBARKEIT' | 'VORMERKUNG' | 'ANMERKUNG' | 'GRUNDLAST' | 'PFANDRECHT' | 'SDR_DIENSTBARKEIT' | 'EIGENTUM_ANTEIL';
    export const ArtEnum = {
        DIENSTBARKEIT: 'DIENSTBARKEIT' as ArtEnum,
        VORMERKUNG: 'VORMERKUNG' as ArtEnum,
        ANMERKUNG: 'ANMERKUNG' as ArtEnum,
        GRUNDLAST: 'GRUNDLAST' as ArtEnum,
        PFANDRECHT: 'PFANDRECHT' as ArtEnum,
        SDRDIENSTBARKEIT: 'SDR_DIENSTBARKEIT' as ArtEnum,
        EIGENTUMANTEIL: 'EIGENTUM_ANTEIL' as ArtEnum
    };
}


